import _ from 'lodash';
import platformUtils from './platformUtils';
import WixEvent from '../ui/events/WixEvent';
import MouseEvent from '../ui/events/MouseEvent';
import KeyboardEvent from '../ui/events/KeyboardEvent';
import HtmlComponentMessageEvent from '../ui/events/HtmlComponentMessageEvent';
import GalleryItemClickedEvent from '../ui/events/GalleryItemClickedEvent';
import GalleryItemChangedEvent from '../ui/events/GalleryItemChangedEvent';
import GoogleMapClickEvent from '../ui/events/GoogleMapClickEvent';
import TableCellEvent from '../ui/events/TableCellEvent';
import TableRowEvent from '../ui/events/TableRowEvent';
import IconMouseInEvent from '../ui/events/IconMouseInEvent';
import QuickActionBarItemClickedEvent from '../ui/events/QuickActionBarItemClickedEvent';

export default function createEventFrom (data, controllerId) {
    const RMI = platformUtils.getRMI();
    const wixSelector = platformUtils.getWixSelector();
    const comp = wixSelector.getInstance(RMI, RMI.getType(data.compId), data.compId, controllerId);
    const EventTypes = RMI.getEventTypes();
    const type = _.get(data, 'event.action') || _.get(data, 'event.type');
    if (_.isUndefined(type)) {
        return new WixEvent(comp);
    }

    switch(type) {
        case EventTypes.MOUSE_IN:
        case EventTypes.MOUSE_OUT:
        case EventTypes.CLICK:
        case EventTypes.DBL_CLICK:
        case EventTypes.SCREEN_IN:
            return new MouseEvent(comp, data.event);
        case EventTypes.IMAGE_EXPANDED:
        case EventTypes.IMAGE_CHANGED:
            return new GalleryItemChangedEvent(comp, data.event);
        case EventTypes.KEY_PRESS:
            return new KeyboardEvent(comp, data.event);
        case EventTypes.MESSAGE:
            return new HtmlComponentMessageEvent(comp, data.event);
        case EventTypes.ITEM_CLICKED:
            return new GalleryItemClickedEvent(comp, data.event);
        case EventTypes.CELL_EDIT:
        case EventTypes.CELL_SELECT:
            return new TableCellEvent(comp, data.event);
        case EventTypes.ROW_SELECT:
            return new TableRowEvent(comp, data.event);
        case EventTypes.ICON_MOUSE_IN:
            return new IconMouseInEvent(comp, data.event);
        case EventTypes.QUICK_ACTION_BAR_ITEM_CLICKED:
            return new QuickActionBarItemClickedEvent(comp, data.event);
        case EventTypes.GOOGLE_MAP_CLICKED:
        case EventTypes.GOOGLE_MAP_MARKER_CLICKED:
            return new GoogleMapClickEvent(comp, data.event, EventTypes, type);
        default:
            return new WixEvent(comp, data.event);
    }
}

